
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("882Qs", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e664998f36f6457c$export$1c108e9c11520cac = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "BwMOJ",
    name: "ContentTreeSearchEmptyLoader",
    loader: async ()=>(await (parcelRequire("aMOfG"))).ContentTreeSearchEmpty
});

const $e664998f36f6457c$export$f3cc49687d3dd9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KEbqE",
    name: "ContentTreeSearchErrorLoader",
    loader: async ()=>(await (parcelRequire("aMOfG"))).ContentTreeSearchError
});
module.exports["ContentTreeSearchEmptyLoader"] = $e664998f36f6457c$export$1c108e9c11520cac;
module.exports["ContentTreeSearchErrorLoader"] = $e664998f36f6457c$export$f3cc49687d3dd9d7;

});

parcelRegister("aMOfG", function(module, exports) {

let $7da55e0db7745518$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7da55e0db7745518$var$load("6FaFk").then(()=>parcelRequire('wyyi4'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("5oz05", function(module, exports) {
/**
 * @generated SignedSource<<afd796964a41dbcef986dcaa808d5950>>
 * @relayHash 83fe03e4bf3c53079ba8fc5909b9c487
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e803913c940138899e1c84749aac24260f42d50e667a0fe0dedcbfb86e618092
const $e8ae638795b2b78e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchText"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchText"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "concreteType": "ConfluenceContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ConfluenceContentTitleEmoji",
                        "kind": "LinkedField",
                        "name": "titleEmojiPublished",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ConfluencePage"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentTreeSearchContentTreeSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentTreeSearchContentTreeSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v5 /*: any*/ 
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "83fe03e4bf3c53079ba8fc5909b9c487",
            "id": "e803913c940138899e1c84749aac24260f42d50e667a0fe0dedcbfb86e618092",
            "metadata": {},
            "name": "useContentTreeSearchContentTreeSearchQuery",
            "operationKind": "query",
            "text": "query useContentTreeSearchContentTreeSearchQuery($experience:String!,$searchText:String!,$first:Int,$filters:SearchFilterInput!){search{search(experience:$experience,query:$searchText,first:$first,filters:$filters){edges{node{__typename,id,title,type,...on SearchConfluencePageBlogAttachment{entityId,confluenceEntity{__typename,...on ConfluencePage{id,subtype,metadata{titleEmojiPublished{id,value}}},...on Node{__isNode:__typename,id}}}}}}}}"
        }
    };
}();
$e8ae638795b2b78e$var$node.hash = "95d3c3eee93e0115b50c32fd07cd47e2";
var $e8ae638795b2b78e$export$2e2bcd8739ae039 = $e8ae638795b2b78e$var$node;



var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $gKr8t = parcelRequire("gKr8t");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $56QzY = parcelRequire("56QzY");

/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $748ce020ea1d386c$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $748ce020ea1d386c$export$77cdd20d47be2a2f = /*#__PURE__*/ function(SearchCombinationType) {
    SearchCombinationType["AND"] = "AND";
    SearchCombinationType["OR"] = "OR";
    return SearchCombinationType;
}({});
var $748ce020ea1d386c$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["CURRENT"] = "CURRENT";
    SearchConfluenceDocumentStatus["ARCHIVED"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["DRAFT"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({});
var $748ce020ea1d386c$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchConfluenceRangeField["CREATED"] = "CREATED";
    return SearchConfluenceRangeField;
}({});
var $748ce020ea1d386c$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["ARCHIVED"] = "ARCHIVED";
    SearchContainerStatus["CURRENT"] = "CURRENT";
    return SearchContainerStatus;
}({});
var $748ce020ea1d386c$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["OPEN"] = "OPEN";
    SearchIssueStatusCategory["DONE"] = "DONE";
    return SearchIssueStatusCategory;
}({});
var $748ce020ea1d386c$export$f83401feaa563e1e = /*#__PURE__*/ function(SearchLinkedEntityGranularity) {
    SearchLinkedEntityGranularity["FULL_THREAD"] = "FULL_THREAD";
    SearchLinkedEntityGranularity["ALL_MATCHING_MESSAGES"] = "ALL_MATCHING_MESSAGES";
    SearchLinkedEntityGranularity["DEFAULT"] = "DEFAULT";
    return SearchLinkedEntityGranularity;
}({});
var $748ce020ea1d386c$export$45f36aeb819dbce5 = /*#__PURE__*/ function(SearchParticipantType) {
    SearchParticipantType["MENTIONS"] = "MENTIONS";
    SearchParticipantType["CONTRIBUTOR"] = "CONTRIBUTOR";
    SearchParticipantType["PRESENCE"] = "PRESENCE";
    return SearchParticipantType;
}({});
var $748ce020ea1d386c$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["software"] = "software";
    SearchProjectType["business"] = "business";
    SearchProjectType["service_desk"] = "service_desk";
    SearchProjectType["product_discovery"] = "product_discovery";
    return SearchProjectType;
}({});
var $748ce020ea1d386c$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["database"] = "database";
    SearchResultType["whiteboard"] = "whiteboard";
    SearchResultType["embed"] = "embed";
    SearchResultType["folder"] = "folder";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["dashboard"] = "dashboard";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["goal"] = "goal";
    SearchResultType["project_update"] = "project_update";
    SearchResultType["goal_update"] = "goal_update";
    SearchResultType["tag"] = "tag";
    SearchResultType["focus_area"] = "focus_area";
    SearchResultType["focus_area_status_update"] = "focus_area_status_update";
    SearchResultType["ask"] = "ask";
    SearchResultType["question"] = "question";
    SearchResultType["learning"] = "learning";
    SearchResultType["document"] = "document";
    SearchResultType["repository"] = "repository";
    SearchResultType["component"] = "component";
    SearchResultType["presentation"] = "presentation";
    SearchResultType["spreadsheet"] = "spreadsheet";
    SearchResultType["message"] = "message";
    SearchResultType["object_schema"] = "object_schema";
    SearchResultType["object_type"] = "object_type";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $748ce020ea1d386c$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchThirdPartyRangeField["CREATED"] = "CREATED";
    return SearchThirdPartyRangeField;
}({})// Note: Original file contained additional custom exports that need manual review:
// SearchAssetsFilter, SearchAssetsObjectSchemaFilter, SearchAssetsObjectTypeFilter, SearchBoardFilter, SearchCommonFilter, SearchCommonRangeFilter, SearchCommonRangeFilterFields, SearchCompassComponentFilter, SearchCompassFilter, SearchConfluenceFilter, SearchConfluenceRangeFilter, SearchExternalContainerFilter, SearchExternalContentFormatFilter, SearchExternalDepthFilter, SearchExternalFilter, SearchFilterInput, SearchJiraFilter, SearchJiraIssueFilter, SearchJiraProjectFilter, SearchMercuryFilter, SearchParticipant, SearchParticipants, SearchThirdPartyFilter, SearchThirdPartyProduct, SearchThirdPartyRangeFilter, SearchTrelloFilter
// Please verify these are handled correctly in your codebase.
;


const $a306f397805d802c$var$SEARCH_PAGE_SIZE = 50;
const $a306f397805d802c$var$transformSearchData = (data)=>{
    const nodes = data?.search?.search?.edges?.map((edge)=>edge.node) || undefined;
    return nodes?.map(({ entityId: entityId, title: title, type: type, confluenceEntity: confluenceEntity })=>({
            id: entityId,
            title: title,
            displayEmoji: confluenceEntity?.metadata?.titleEmojiPublished?.value,
            type: type,
            subType: confluenceEntity?.subtype?.toLowerCase() ?? '',
            // TODO: Show super admins which pages are restricted -- this info is not yet available in AGG
            hasRestrictions: false,
            hasInheritedRestrictions: false
        }));
};
const $a306f397805d802c$export$701bedbfad07b1e = (searchText, source, spaceKey)=>{
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const resolvedSpaceKey = spaceKey ?? pageSpaceKey; // Use provided spaceKey or fall back to context
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(resolvedSpaceKey);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $e8ae638795b2b78e$export$2e2bcd8739ae039), {
        variables: {
            searchText: searchText,
            experience: 'confluence.searchInTree',
            first: $a306f397805d802c$var$SEARCH_PAGE_SIZE,
            filters: {
                entities: [
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:whiteboard',
                    'ati:cloud:confluence:database',
                    'ati:cloud:confluence:embed'
                ],
                locations: [
                    'ari:cloud:confluence::site/'.concat(cloudId)
                ],
                confluenceFilters: {
                    spacesFilter: resolvedSpaceKey ? [
                        resolvedSpaceKey
                    ] : undefined,
                    contentStatuses: [
                        (0, $748ce020ea1d386c$export$75fb70288e44d634).CURRENT
                    ],
                    titleMatchOnly: true
                }
            }
        },
        client: (0, $gKr8t.getAGGClient)(),
        skip: searchText.length === 0
    });
    const searchResult = (0, $42omo.useMemo)(()=>$a306f397805d802c$var$transformSearchData(data), [
        data
    ]);
    (0, $42omo.useEffect)(()=>{
        if (searchResult) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'searched',
                actionSubject: 'contentTree',
                source: source,
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    searchResultCount: searchResult.length,
                    navdexPointType: (0, $56QzY.TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        searchResult,
        spaceId,
        source
    ]);
    return {
        searchResult: searchResult,
        loading: loading,
        error: error
    };
};
module.exports["useContentTreeSearch"] = $a306f397805d802c$export$701bedbfad07b1e;

});


//# sourceMappingURL=MovePageDialog.88796f6b.js.map
